import { createContext } from 'react';
import { LanguageType } from '@/custom-types';

export const UserLanguageContext = createContext<LanguageType | null>(null);